"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeBaseMockRouteInput = makeBaseMockRouteInput;
const lodash_1 = __importDefault(require("lodash"));
const MockLog_1 = require("./MockLog");
/**
 * Create a mock route input value that the server expects in route handlers.
 */
function makeBaseMockRouteInput(props) {
    const mockLog = props.mockLog || (0, MockLog_1.makeMockLog)();
    return {
        requestId: "test-request",
        method: props.method || lodash_1.default.get(props, "routeConfig.method") || "POST",
        url: props.url || lodash_1.default.get(props, "routeConfig.url") || "/",
        params: props.params || {},
        query: props.query || {},
        body: props.body || {},
        log: mockLog.pinoInst,
    };
}
//# sourceMappingURL=MockRouteInput.js.map